/**
 * What a **Lieferung**'s dispatch failed on (TM-9636, Versand console).
 *
 * ⚠ **A waiting reason is not a failure.** If a Lieferung waits for an address
 * or a certificate, nothing was attempted; that stands in `blockers` and not
 * here.
 */
export var LieferungDispatchFailureKind;
(function (LieferungDispatchFailureKind) {
    /** Our own mail server was unreachable — an operational incident. */
    LieferungDispatchFailureKind["TRANSPORT_UNREACHABLE"] = "TRANSPORT_UNREACHABLE";
    /** The mail server answered, and the answer was a no. */
    LieferungDispatchFailureKind["TRANSPORT_REJECTED"] = "TRANSPORT_REJECTED";
    /**
     * The mail is out, but its transaction was refused at commit — there is **no
     * Versandversuch**, although the Annahmestelle has the file. A human decides
     * about a second attempt (TM-9637).
     */
    LieferungDispatchFailureKind["COMMIT_AFTER_HANDOVER"] = "COMMIT_AFTER_HANDOVER";
    /** Everything else — the reason stands in the text. */
    LieferungDispatchFailureKind["OTHER"] = "OTHER";
})(LieferungDispatchFailureKind || (LieferungDispatchFailureKind = {}));
//# sourceMappingURL=lieferung-dispatch-failure-kind.enum.js.map